const LocalModeIndicator = () => {
  return (
    <div className="bg-secondary-500 text-white shadow-md flex flex-row text-xs rounded-sm p-[1px] pointer-events-auto group cursor-pointer">
      <div className="py-1 px-2 flex justify-center items-center gap-2">
        <p className="font-bold text-2xs leading-none tracking-none">Local</p>
        <div
          className={"w-2 h-2 rounded-full bg-blue-500 group-hover:bg-blue-400"}
        />
      </div>
    </div>
  );
};

export default LocalModeIndicator;
